import React from 'react';
import Icon from './Icon';

/**
 * 어드민 리스트 툴바용 보조 액션 버튼.
 * FilterButton 과 동일한 사이즈/타이포(`h-8 px-3 text-xs font-medium`) 로 고정 — 같은 줄에 나란히
 * 배치될 때 시각적 일관성 보장. 페이지마다 Button(size=sm/level=...) 으로 흩어져 있던 회귀를
 * 한 컴포넌트로 통일.
 *
 * variant
 *  - 'default' : 흰 배경 + 회색 테두리 (선택 취소, 초기화, 비활성화 등)
 *  - 'danger'  : 빨강 텍스트 + 빨강 테두리 (삭제 등 파괴적 액션)
 *  - 'primary' : 짙은 배경 (강조 액션)
 */
export default function AdminActionButton({
  children,
  onClick,
  variant = 'default',
  iconName,
  disabled = false,
  className = '',
  type = 'button',
}) {
  const variants = {
    default: 'bg-white border-mono-200 text-mono-900 hover:bg-mono-50',
    danger:  'bg-white border-red-200 text-red-600 hover:bg-red-50',
    primary: 'bg-mono-900 border-mono-900 text-white hover:bg-mono-800',
  };
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`flex items-center gap-1.5 h-8 px-3 border rounded-lg text-xs font-medium transition-colors whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed ${variants[variant] || variants.default} ${className}`}
    >
      {iconName && <Icon name={iconName} size={16} />}
      {children}
    </button>
  );
}
